<app-page-breadcrumb pageTitle="Categorías de Producto"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Controles -->
  <div class="flex items-center justify-end gap-1.5 flex-wrap">
    <button
      type="button"
      (click)="toggleFilters()"
      class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5"
    >
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
        ></path>
      </svg>
      {{ showFilters ? 'Ocultar' : 'Filtros' }}
    </button>
    <button
      type="button"
      (click)="nuevaCategoria()"
      class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
    >
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 4v16m8-8H4"
        ></path>
      </svg>
      Nueva Categoría
    </button>
  </div>

  <!-- Filtros -->
  @if (showFilters) {
    <div
      class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3"
    >
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Buscar por nombre</label
          >
          <input
            type="text"
            [(ngModel)]="filtroNombre"
            placeholder="Nombre de la categoría..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Padre</label
          >
          <select
            [(ngModel)]="filtroParent"
            (change)="expandAll()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todas</option>
            <option [ngValue]="0">Independientes</option>
            @for (cat of categoriasPadre; track cat.id) {
              <option [ngValue]="cat.id">{{ cat.name }}</option>
            }
          </select>
        </div>
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
            >Estado</label
          >
          <select
            [(ngModel)]="filtroIsActive"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos</option>
            <option [ngValue]="true">Activos</option>
            <option [ngValue]="false">Inactivos</option>
          </select>
        </div>
        <div class="flex items-end md:col-span-3">
          <button
            type="button"
            (click)="limpiarFiltro()"
            class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
      ></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400"
        >Cargando categorías...</span
      >
    </div>
  }

  <!-- Error -->
  @if (error) {
    <div
      class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
    >
      <div class="flex items-center gap-3">
        <svg
          class="w-5 h-5 text-error-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
  }

  <!-- ===== VISTA ÁRBOL (con columnas) ===== -->
  @if (!loading && !error) {
    <div
      class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]"
    >
      <!-- Header del árbol -->
      <div
        class="flex items-center justify-between px-4 py-2.5 border-b border-gray-100 dark:border-white/[0.05] bg-gray-50 dark:bg-white/[0.02]"
      >
        <span
          class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide"
        >
          Estructura de categorías
        </span>
        <div class="flex items-center gap-2">
          <button
            type="button"
            (click)="expandAll()"
            class="text-xs text-brand-600 dark:text-brand-400 hover:underline"
          >
            Expandir todo
          </button>
          <span class="text-gray-300 dark:text-gray-600">|</span>
          <button
            type="button"
            (click)="collapseAll()"
            class="text-xs text-brand-600 dark:text-brand-400 hover:underline"
          >
            Colapsar todo
          </button>
        </div>
      </div>

      <div class="max-w-full overflow-x-auto custom-scrollbar">
        <div class="min-w-[760px]">
          <!-- Cabecera de columnas -->
          <div
            class="grid items-center gap-3 px-4 py-3 border-b border-gray-100 dark:border-white/[0.05] text-theme-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
            [style.gridTemplateColumns]="gridCols"
          >
            <div>Nombre</div>
            <div>Descripción</div>
            <div>Padre</div>
            <div>Tipo</div>
            <div>Estado</div>
            <div class="text-center">Acciones</div>
          </div>

          @if (categoriasTree.length === 0) {
            <div class="px-5 py-8 text-center text-gray-500 dark:text-gray-400">
              No hay categorías registradas
            </div>
          }

          <!-- Nodos raíz -->
          <div class="divide-y divide-gray-100 dark:divide-white/[0.05]">
            @for (cat of categoriasTree; track cat.id) {
              <ng-container
                *ngTemplateOutlet="
                  treeNode;
                  context: { $implicit: cat, depth: 0 }
                "
              ></ng-container>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Template recursivo del nodo -->
    <ng-template
      #treeNode
      let-cat
      let-depth="depth"
    >
      <div
        class="grid items-center gap-3 px-4 py-2.5 hover:bg-gray-50 dark:hover:bg-white/[0.02] transition-colors text-theme-sm"
        [class.opacity-60]="!cat.isActive"
        [style.gridTemplateColumns]="gridCols"
      >
        <!-- Columna Nombre (con indentación de árbol) -->
        <div
          class="flex items-center gap-2 min-w-0"
          [style.padding-left.px]="depth * 24"
        >
          @if (tieneHijos(cat.id)) {
            <button
              type="button"
              (click)="toggleNode(cat.id)"
              class="flex items-center justify-center w-5 h-5 rounded text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors shrink-0"
            >
              <svg
                class="w-3.5 h-3.5 transition-transform"
                [class.rotate-90]="isExpanded(cat.id)"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          } @else {
            <span class="w-5 h-5 flex items-center justify-center shrink-0">
              <span
                class="w-1.5 h-1.5 rounded-full bg-gray-300 dark:bg-gray-600"
              ></span>
            </span>
          }

          @if (tieneHijos(cat.id)) {
            <svg
              class="w-4 h-4 shrink-0"
              [class.text-brand-400]="isExpanded(cat.id)"
              [class.text-gray-400]="!isExpanded(cat.id)"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"
              />
            </svg>
          } @else {
            <svg
              class="w-4 h-4 text-gray-300 dark:text-gray-600 shrink-0"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
              />
            </svg>
          }

          <span class="font-medium text-gray-800 dark:text-white/90 truncate">{{
            cat.name
          }}</span>
        </div>

        <!-- Descripción -->
        <div class="min-w-0">
          @if (cat.description) {
            <span
              class="text-xs text-gray-500 dark:text-gray-400 truncate block"
              >{{ cat.description }}</span
            >
          } @else {
            <span class="text-xs text-gray-400 dark:text-gray-500 italic"
              >Sin descripción</span
            >
          }
        </div>

        <!-- Padre -->
        <div class="text-gray-500 dark:text-gray-400 truncate">
          {{ getParentLabel(cat) }}
        </div>

        <!-- Tipo -->
        <div>
          <app-badge [color]="getTipoColor(cat.type)">{{
            getTipoLabel(cat.type)
          }}</app-badge>
        </div>

        <!-- Estado -->
        <div>
          <app-badge [color]="getActiveColor(cat)">{{
            getActiveLabel(cat)
          }}</app-badge>
        </div>

        <!-- Acciones -->
        <div class="flex items-center justify-center gap-1">
          <button
            (click)="editarCategoria(cat)"
            class="rounded-lg p-1.5 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors text-gray-500"
            title="Editar"
          >
            <svg
              class="w-3.5 h-3.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
          </button>
          <button
            (click)="eliminarCategoria(cat)"
            class="rounded-lg p-1.5 hover:bg-error-50 hover:text-error-600 transition-colors text-gray-500"
            title="Eliminar"
          >
            <svg
              class="w-3.5 h-3.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </button>
        </div>
      </div>

      <!-- Hijos (recursivo) -->
      @if (tieneHijos(cat.id) && isExpanded(cat.id)) {
        @for (hijo of getDirectChildren(cat.id); track hijo.id) {
          <ng-container
            *ngTemplateOutlet="
              treeNode;
              context: { $implicit: hijo, depth: depth + 1 }
            "
          ></ng-container>
        }
      }
    </ng-template>
  }
</div>
